export default __webpack_public_path__ + "static/media/insta1.8181284d.jpg";